export * from './top-issues';
export * from './tickets';
export * from './kb';
export var HistogramInterval;
(function (HistogramInterval) {
    HistogramInterval[HistogramInterval["MINUTE"] = 0] = "MINUTE";
    HistogramInterval[HistogramInterval["HOUR"] = 1] = "HOUR";
    HistogramInterval[HistogramInterval["DAY"] = 2] = "DAY";
})(HistogramInterval || (HistogramInterval = {}));
//# sourceMappingURL=index.js.map